import type {Resolve, Reject} from "../utility/InterfacePromise";

import {
    E24UserFeedbackRequest, EudUserFeedback,
} from "@ev24/proto-eud-luna-web-api/elwa_v1_pb";
import {
    EudUserMessagingServiceClient
} from "@ev24/proto-eud-luna-web-api/elwa_v1_grpc_web_pb";
import type grpcWeb from "grpc-web";
import GRPCLuna from "./GRPCLuna";


export interface FeedbackFields {
  token: string; // Auth token
  related_to: string; // URL
  comment: string; // users comments
}

export default class LunaFeedback extends GRPCLuna {

    public async send(fields: FeedbackFields, recaptchaToken: string | undefined = '') {
        const UUID = this.getUuid();

        const payload: EudUserFeedback = new EudUserFeedback();
        payload.setRelatedTo(fields.related_to)
        payload.setComment(fields.comment)
        payload.getMetaMap().set('time', new Date().toISOString())

        const request: E24UserFeedbackRequest = new E24UserFeedbackRequest();
        request.setPayload(payload)
        request.setToken(fields.token)
        request.setRequestId(UUID);
        request.setRecaptchaToken(recaptchaToken || '')
        if(fields.token) {
            request.setToken(fields.token);
        }

        return new Promise((resolve: Resolve, reject: Reject): void => {
            const serviceClient = new EudUserMessagingServiceClient(this._path, this._options);
            serviceClient.sendFeedback(
                request,
                this._headers,
                (err: grpcWeb.RpcError, response) => {
                    this.genericHandler("Thank you the feedback.", response, err, resolve, reject);
                }
            );
        });
    }


}